import { object, string } from '~utils/validation';

export default object({
  cellphone: string()
    .cellphone('Número de telefone inválido')
    .required('O campo é obrigatório.'),
  email: string().email().required('O campo é obrigatório.'),
  name: string().required('O campo é obrigatório.'),
});
